<template>
  <div id="document-viewer" role="document">
    <HeaderDocument v-if="aknString" :docUri="docUri" :year="this.$route.params.year" :number="this.$route.params.number"/>
    <ModalDocumentInfo ref="modalInfo" v-if="aknString" :aknString="aknString" :year="this.$route.params.year" :number="this.$route.params.number"/>
    <section class="container px-4 my-4">
      <div class="row" v-if="aknString" >
        <b-container class="main-container" fluid>
          <b-row>
            <b-col cols="3" class="index-col d-none d-md-block affix-parent">
              <div
                ref="aknIndex"
                class="sidebar-wrapper it-line-right-side affix-top"
                >
                <div class="sidebar-linklist-wrapper">
                  <h3>Indice Dei Contenuti</h3>
                  <div class="link-list-wrapper">
                    <ul class="link-list">
                      <li v-for="item in aknIndex" v-bind:key="item.name">
                        <a v-if="item.hierarchies"
                          href="#collapseArticolato"
                          data-toggle="collapse"
                          aria-expanded="false"
                          aria-controls="collapseArticolato"
                          class="list-item large medium right-icon">
                            <span>{{item.localeLabel}}</span>
                              <svg class="icon icon-sm icon-primary right" aria-hidden="true">
                                <use :xlink:href="icons.itExpand"></use>
                              </svg>
                          </a>
                          <ul class="link-sublist collapse show" id="collapseArticolato">
                            <li v-for="hier in item.hierarchies" v-bind:key="hier.xpath">
                              <a  v-if="hier.level === 1"
                                  class="list-item"
                                  :href="hier.eId"
                                  v-on:click.prevent="goToPartition(hier)"
                                  data-attribute="forward">
                                <span>{{hier.localeLabel}}</span>
                              </a>
                            </li>
                          </ul>
                        <a
                          v-if="!item.hierarchies"
                          class="list-item large medium right-icon"
                          :href="item.eId"
                          v-on:click.prevent="goToPartition(item)"
                          data-attribute="forward">
                          >
                          <span class="">{{item.localeLabel}}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col sm="12" lg="9" md="10">
              <div class="container document-section">
                <AknVisualizer
                  ref="aknVisualizer"
                  v-if="aknString"
                  :akn-string="getAknString"
                  :theme="'designItalia'" />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="row" v-else>
        <div class="col-lg-12 px-lg-12 py-lg-12">
          <h6>
            Dammi qualche secondo, sto scaricando il tuo documento!
          </h6>
          <Spinner />
        </div>
      <!--  <div class="row border-top row-column-border row-column-menu-left"  v-id="false">
          <aside class="col-lg-4" style="position: relative;">
            <div class="sticky-wrapper navbar-wrapper is-sticky" style="top: 56px; width: 383px;">
              <nav class="navbar it-navscroll-wrapper it-top-navscroll navbar-expand-lg">
                <button class="custom-navbar-toggler" type="button" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" data-target="#navbarNav"><span class="it-list"></span>Cos'è</button>
                <div class="navbar-collapsable" id="navbarNav">
                  <div class="overlay"></div>
                    <div class="close-div sr-only">
                      <button class="btn close-menu" type="button">
                        <span class="it-close"></span>Chiudi
                      </button>
                    </div>
                    <a class="it-back-button" href="#">
                      <svg class="icon icon-sm icon-primary align-top">
                        <use xlink:href="/bootstrap-italia/dist/svg/sprite.svg#it-chevron-left"></use>
                      </svg>
                      <span>Torna indietro</span>
                    </a>
                    <div class="menu-wrapper">
                      <div class="link-list-wrapper menu-link-list">
                        <h3 class="no_toc">Indice della pagina</h3>
                        <ul class="link-list">
                          <li v-for="item in aknIndex" v-bind:key="item.name">
                            <a v-if="item.hierarchies"
                              href="#collapseArticolato"
                              data-toggle="collapse"
                              aria-expanded="false"
                              aria-controls="collapseArticolato"
                              class="list-item large medium right-icon">
                                <span>{{item.localeLabel}}</span>
                                  <svg class="icon icon-sm icon-primary right" aria-hidden="true">
                                    <use :xlink:href="icons.itExpand"></use>
                                  </svg>
                              </a>
                              <ul class="link-sublist collapse show" id="collapseArticolato">
                                <li v-for="hier in item.hierarchies" v-bind:key="hier.xpath">
                                  <a  v-if="hier.level === 1"
                                      class="list-item"
                                      :href="hier.eId"
                                      v-on:click.prevent="goToPartition(hier)"
                                      data-attribute="forward">
                                    <span>{{hier.localeLabel}}</span>
                                  </a>
                                </li>
                              </ul>
                              <a
                                v-if="!item.hierarchies"
                                class="list-item large medium right-icon"
                                :href="item.eId"
                                v-on:click.prevent="goToPartition(item)"
                                data-attribute="forward">
                                >
                                <span class="">{{item.localeLabel}}</span>
                              </a>
                            </li>
                          </ul>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </aside>
            <section class="col-lg-8 it-page-sections-container">
              <article v-if="aknString" id="cos-e" class="it-page-section anchor-offset">
                <AknVisualizer
                  ref="aknVisualizer"
                  v-if="aknString"
                  :akn-string="getAknString"
                  :theme="'designItalia'" />
              </article>
            </section>
          </div>


      --></div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import akomandoTree from 'akomando-tree';
import VueScrollTo from 'vue-scrollto';

import sprites from 'bootstrap-italia/dist/svg/sprite.svg';
import AknVisualizer from '@/components/imports/AknVisualizer';
import HeaderDocument from '@/components/layout/header/HeaderDocument';
import ModalDocumentInfo from '@/components/layout/accessory/ModalDocumentInfo';
import Spinner from '@/components/layout/accessory/Spinner';


export default {
  name: 'document',
  components: {
    AknVisualizer,
    HeaderDocument,
    ModalDocumentInfo,
    Spinner,
  },
  breadcrumb: {
    label: 'Document',
  },
  props: ['docUri'],
  watch: {
    // eslint-disable-next-line object-shorthand
    '$route'(to) {
      this.getDocument(to);
    },
  },
  mounted() {
    // const testXML = await Vue.axios.get('static/akn-docs/CorteCostituzionale
    // _1956_2018/2018/sentenza/akn_it_judgment_sentenza_cost_2018_141/
    // akn_it_judgment_sentenza_cost_2018_141_ita@_!main.xml');
    this.getDocument();
  },
  computed: {
    getAknString() {
      return this.aknString;
    },
  },
  methods: {
    async getDocument() {
      this.aknString = null;
      const separator = (process.env.NODE_ENV === 'development') ? '?' : '&';
      const url = `${Vue.prototype.$proxy}getDocument.xq${separator}uri=${this.docUri}&year=${this.$route.params.year}&number=${this.$route.params.number}`;
      const document = await Vue.axios.get(url);
      const aknXml = document.data;
      this.aknString = aknXml;
      akomandoTree.locale = 'it_it_judgment_corte_costituzionale';
      this.aknIndex = await akomandoTree.getIndex({
        aknString: aknXml,
      });
      this.windowHeight = window.innerHeight;
    },
    goToPartition(partition) {
      const foundPartition = this.$refs.aknVisualizer.findElements(partition.xpath);
      VueScrollTo.scrollTo(foundPartition[0],
        500, {
          offset: -50,
        },
      );
    },
    getIndexHeight() {
      return `height: ${this.windowHeight}px`;
    },
    getHierChildrens(item, hierarchies) {
      const itemXPath = item.xpath;
      const children = [];
      hierarchies.forEach((anItem) => {
        if (anItem.xpath.startsWith(itemXPath) && anItem.xpath !== itemXPath) {
          children.push(anItem);
        }
      });
      return children;
    },
  },
  data() {
    return {
      aknIndex: null,
      aknString: null,
      windowHeight: null,
      icons: {
        itExpand: `${sprites}#it-expand`,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .sidebar-linklist-wrapper {
    padding-top:70px;
    height:1300px;
    overflow-y: auto;
  }
  .document-section{
    padding:30px;
    *{
      text-align: justify!important;
    }
  }
</style>






// WEBPACK FOOTER //
// src/components/pages/Document.vue